import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { Keyboard, KeyboardResize } from "@capacitor/keyboard";

/**
 * The static capacitor.config sets Keyboard.resize to "none" because on Android
 * the edge-to-edge plugin (@capawesome) handles the keyboard resize and the
 * Capacitor keyboard plugin must stay passive to avoid double-counting.
 *
 * iOS has no such plugin and relies on Capacitor's built-in keyboard resize, so
 * "none" would let the keyboard overlay inputs. Override iOS to "native" here.
 */
export const useKeyboardResize = () => {
  useEffect(() => {
    if (Capacitor.getPlatform() !== "ios") return;
    Keyboard.setResizeMode({ mode: KeyboardResize.Native }).catch(() => {});
  }, []);
};
